/**
 * JNF Frontend Role Permissions
 * Mirrors backend/utils/roles.js — keep in sync.
 */

export const ROLE_RANK = {
  pending:        0,
  the_lovers:     1,
  general_member: 2,
  fully_member:   3,
  muqaddam:       4,
};

export const ACCESS_LEVEL_RANK = {
  public:     0,
  the_lovers: 1,
  general:    2,
  full:       3,
};

export const ROLE_INFO = {
  pending: {
    label:       'Pending',
    label_ar:    'قيد الانتظار',
    description: 'Awaiting role assignment from admin',
    color:       'bg-gray-100 text-gray-500',
    badgeColor:  '#6b7280',
    icon:        '⏳',
  },
  the_lovers: {
    label:       'The Lovers',
    label_ar:    'المحبون',
    description: 'Seekers interested in the Tijaniyyah path',
    color:       'bg-pink-100 text-pink-700',
    badgeColor:  '#ec4899',
    icon:        '💛',
  },
  general_member: {
    label:       'General Member',
    label_ar:    'عضو عام',
    description: 'Member growing in knowledge of Allah',
    color:       'bg-blue-100 text-blue-700',
    badgeColor:  '#3b82f6',
    icon:        '📖',
  },
  fully_member: {
    label:       'Fully Member',
    label_ar:    'عضو كامل',
    description: 'Initiated member with knowledge of Allah',
    color:       'bg-green-100 text-green-700',
    badgeColor:  '#22c55e',
    icon:        '✅',
  },
  muqaddam: {
    label:       'Muqaddam',
    label_ar:    'مقدّم',
    description: 'Senior member authorised to guide others',
    color:       'bg-amber-100 text-amber-700',
    badgeColor:  '#f59e0b',
    icon:        '🌟',
  },
};

/** Check if a member role meets a minimum access level */
export const canAccess = (memberRole, accessLevel) => {
  const memberRank   = ROLE_RANK[memberRole]          ?? 0;
  const requiredRank = ACCESS_LEVEL_RANK[accessLevel] ?? 0;
  return memberRank >= requiredRank;
};

/** Dashboard nav sections visible per role — Azkar removed */
export const DASHBOARD_SECTIONS = {
  pending:        ['profile'],
  the_lovers:     ['profile', 'dhikr'],
  general_member: ['profile', 'gallery', 'dhikr'],
  fully_member:   ['profile', 'gallery', 'documents', 'dhikr', 'directory'],
  muqaddam:       ['profile', 'gallery', 'documents', 'dhikr', 'directory'],
};

/** Ordered list for role assignment dropdown (admin) */
export const ASSIGNABLE_ROLES = [
  { value: 'the_lovers',     ...ROLE_INFO.the_lovers     },
  { value: 'general_member', ...ROLE_INFO.general_member },
  { value: 'fully_member',   ...ROLE_INFO.fully_member   },
  { value: 'muqaddam',       ...ROLE_INFO.muqaddam       },
];
